import {
  ComponentSize,
  ComponentVariant,
  ComponentAppearance,
} from '../../../types/component.type';

export const tagSizeClasses: Record<NonNullable<ComponentSize>, string> = {
  '2xs': 'px-1.5 py-[0.05rem] text-[0.5rem]',
  xs: 'px-1.5 py-[0.095rem] text-[0.65rem]',
  sm: 'px-2 py-[0.1565rem] text-xs',
  md: 'px-2 py-[0.25rem] text-sm',
  lg: 'px-2.5 py-[0.23rem] text-md',
};

export const tagTextSizeClasses: Record<NonNullable<ComponentSize>, string> = {
  '2xs': 'text-2xs',
  xs: 'text-2xs',
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
};

export const tagTextColorClasses: Record<
  NonNullable<ComponentVariant>,
  string
> = {
  primary: 'text-primary-700',
  secondary: 'text-secondary-700',
  danger: 'text-danger-700',
  warning: 'text-warning-700',
  neutral: 'text-neutral-700',
  success: 'text-success-700',
  info: 'text-blue-700',
  whatsapp: 'text-whatsapp-700',
  call: 'text-call-700',
  email: 'text-email-700',
};

export const tagFilledClasses: Record<NonNullable<ComponentVariant>, string> = {
  primary: 'bg-primary-100 ring-0 text-primary-700',
  secondary: 'bg-secondary-100 ring-0 text-secondary-700',
  danger: 'bg-danger-100 ring-0 text-danger-700',
  warning: 'bg-warning-100 ring-0 text-warning-700',
  neutral: 'bg-neutral-100 ring-0 text-neutral-700',
  success: 'bg-success-100 ring-0 text-success-700',
  info: 'bg-blue-100 ring-0 text-blue-700',
  whatsapp: 'bg-whatsapp-100 ring-0 text-whatsapp-700',
  call: 'bg-call-100 ring-0 text-call-700',
  email: 'bg-email-100 ring-0 text-email-700',
};

export const tagOutlineClasses: Record<
  NonNullable<ComponentVariant>,
  string
> = {
  primary: 'bg-white ring-1 ring-primary-700 text-primary-700',
  secondary: 'bg-white ring-1 ring-secondary-700 text-secondary-700',
  danger: 'bg-white ring-1 ring-danger-700 text-danger-700',
  warning: 'bg-white ring-1 ring-warning-700 text-warning-700',
  neutral: 'bg-white ring-1 ring-neutral-700 text-neutral-700',
  success: 'bg-white ring-1 ring-success-700 text-success-700',
  info: 'bg-white ring-1 ring-blue-700 text-blue-700',
  whatsapp: 'bg-white ring-1 ring-whatsapp-700 text-whatsapp-700',
  call: 'bg-white ring-1 ring-call-700 text-call-700',
  email: 'bg-white ring-1 ring-email-700 text-email-700',
};

export const tagSoftClasses: Record<NonNullable<ComponentVariant>, string> = {
  primary: 'bg-primary-50 ring-1 ring-primary-100 text-primary-700',
  secondary: 'bg-secondary-50 ring-1 ring-secondary-100 text-secondary-700',
  danger: 'bg-danger-50 ring-1 ring-danger-100 text-danger-700',
  warning: 'bg-warning-50 ring-1 ring-warning-100 text-warning-700',
  neutral: 'bg-neutral-50 ring-1 ring-neutral-100 text-neutral-700',
  success: 'bg-success-50 ring-1 ring-success-100 text-success-700',
  info: 'bg-blue-50 ring-1 ring-blue-100 text-blue-700',
  whatsapp: 'bg-whatsapp-50 ring-1 ring-whatsapp-100 text-whatsapp-700',
  call: 'bg-call-50 ring-1 ring-call-100 text-call-700',
  email: 'bg-email-50 ring-1 ring-email-100 text-email-700',
};

export const tagGhostClasses: Record<NonNullable<ComponentVariant>, string> = {
  primary: 'bg-transparent',
  secondary: 'bg-transparent',
  danger: 'bg-transparent',
  warning: 'bg-transparent',
  neutral: 'bg-transparent',
  success: 'bg-transparent',
  info: 'bg-transparent',
  whatsapp: 'bg-transparent',
  call: 'bg-transparent',
  email: 'bg-transparent',
};

export const tagHoverClasses: Record<
  NonNullable<ComponentAppearance>,
  Record<NonNullable<ComponentVariant>, string>
> = {
  filled: {
    primary: 'hover:bg-primary-100',
    secondary: 'hover:bg-secondary-100',
    danger: 'hover:bg-danger-100',
    warning: 'hover:bg-warning-100',
    neutral: 'hover:bg-neutral-100',
    success: 'hover:bg-success-100',
    info: 'hover:bg-blue-100',
    whatsapp: 'hover:bg-whatsapp-100',
    call: 'hover:bg-call-100',
    email: 'hover:bg-email-100',
  },
  outline: {
    primary: 'hover:bg-primary-50',
    secondary: 'hover:bg-secondary-50',
    danger: 'hover:bg-danger-50',
    warning: 'hover:bg-warning-50',
    neutral: 'hover:bg-neutral-50',
    success: 'hover:bg-success-50',
    info: 'hover:bg-blue-50',
    whatsapp: 'hover:bg-whatsapp-50',
    call: 'hover:bg-call-50',
    email: 'hover:bg-email-50',
  },
  soft: {
    primary: 'hover:bg-primary-100',
    secondary: 'hover:bg-secondary-100',
    danger: 'hover:bg-danger-100',
    warning: 'hover:bg-warning-100',
    neutral: 'hover:bg-neutral-100',
    success: 'hover:bg-success-100',
    info: 'hover:bg-blue-100',
    whatsapp: 'hover:bg-whatsapp-100',
    call: 'hover:bg-call-100',
    email: 'hover:bg-email-100',
  },
  ghost: {
    primary: 'hover:bg-primary-50',
    secondary: 'hover:bg-secondary-50',
    danger: 'hover:bg-danger-50',
    warning: 'hover:bg-warning-50',
    neutral: 'hover:bg-neutral-50',
    success: 'hover:bg-success-50',
    info: 'hover:bg-blue-50',
    whatsapp: 'hover:bg-whatsapp-50',
    call: 'hover:bg-call-50',
    email: 'hover:bg-email-50',
  },
};

export const tagHighlightClasses: Record<
  NonNullable<ComponentAppearance>,
  Record<ComponentVariant, string>
> = {
  filled: {
    primary: 'bg-primary-100 ring-primary-700/80',
    secondary: 'bg-secondary-100 ring-secondary-700/80',
    danger: 'bg-danger-100 ring-danger-700/80',
    warning: 'bg-warning-100 ring-warning-700/80',
    neutral: 'bg-neutral-100 ring-neutral-700/80',
    success: 'bg-success-100 ring-success-700/80',
    info: 'bg-blue-100 ring-blue-700/80',
    whatsapp: 'bg-whatsapp-100 ring-whatsapp-700/80',
    call: 'bg-call-100 ring-call-700/80',
    email: 'bg-email-100 ring-email-700/80',
  },
  outline: {
    primary: 'bg-primary-50 ring-2 ring-primary-500',
    secondary: 'bg-secondary-50 ring-2 ring-secondary-500',
    danger: 'bg-danger-50 ring-2 ring-danger-500',
    warning: 'bg-warning-50 ring-2 ring-warning-500',
    neutral: 'bg-neutral-50 ring-2 ring-neutral-500',
    success: 'bg-success-50 ring-2 ring-success-500',
    info: 'bg-blue-50 ring-2 ring-blue-500',
    whatsapp: 'bg-whatsapp-50 ring-2 ring-whatsapp-500',
    call: 'bg-call-50 ring-2 ring-call-500',
    email: 'bg-email-50 ring-2 ring-email-500',
  },
  soft: {
    primary: 'bg-primary-100 ring-1 ring-primary-200',
    secondary: 'bg-secondary-100 ring-1 ring-secondary-200',
    danger: 'bg-danger-100 ring-1 ring-danger-200',
    warning: 'bg-warning-100 ring-1 ring-warning-200',
    neutral: 'bg-neutral-100 ring-1 ring-neutral-200',
    success: 'bg-success-100 ring-1 ring-success-200',
    info: 'bg-blue-100 ring-1 ring-blue-200',
    whatsapp: 'bg-whatsapp-100 ring-1 ring-whatsapp-200',
    call: 'bg-call-100 ring-1 ring-call-200',
    email: 'bg-email-100 ring-1 ring-email-200',
  },
  ghost: {
    primary: 'bg-primary-50',
    secondary: 'bg-secondary-50',
    danger: 'bg-danger-50',
    warning: 'bg-warning-50',
    neutral: 'bg-neutral-50',
    success: 'bg-success-50',
    info: 'bg-blue-50',
    whatsapp: 'bg-whatsapp-50',
    call: 'bg-call-50',
    email: 'bg-email-50',
  },
};
